import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const ThankYouPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 px-4">
      <div className="bg-white shadow-2xl rounded-2xl p-8 max-w-lg w-full text-center animate-fadeIn">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <CheckCircle2 className="w-20 h-20 text-emerald-500 animate-bounce" />
        </div>

        {/* Heading */}
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          🎉 Thank You for Applying!
        </h1>

        {/* Message */}
        <p className="text-gray-600 mb-6 text-lg">
          Your application has been submitted successfully.  
          Our HR team will review it and get back to you soon.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="https://suwasthi.com"
            className="px-6 py-3 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl shadow-lg transition"
          >
            Back to Home
          </Link>

          {/* <Link
            to="/applications"
            className="px-6 py-3 border border-emerald-500 text-emerald-600 hover:bg-emerald-50 rounded-xl shadow-sm transition"
          >
            View My Application
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;